export class ResizeEvent extends Event {
  static get eventName() {
    return 'resize';
  }
  constructor() {
    super(ResizeEvent.eventName);
  }
}